export default class CreateRailwayCompanyStrategy {
  constructor(store) {
    this.store = store;
  }

  save(data) {
    return this.store.dispatch('company/createRailwayCompany', data);
  }
}
